<template>
  <v-bottom-navigation
   style="background-image: linear-gradient(to right,#02aab0 , #00cdac);"
    fixed
    color="green lighten-1"
    class="d-block d-lg-none d-xl-none "
  >
  <v-btn to="/">
      <span>Home</span>
      <v-icon>mdi-home</v-icon>
    </v-btn>
   <v-btn to="/wishlist" >
      <span>Favorites</span>
      <v-icon>mdi-heart</v-icon>
    </v-btn>
  

    <v-btn to="/offerzone">
      <span>Offer Zone</span>
      <v-icon>mdi-gift</v-icon>
    </v-btn>

    <v-btn to="/account">
    
      <span>Account</span>
      <v-icon>mdi-account</v-icon>
    </v-btn>
   
  </v-bottom-navigation>
</template>
<script>
// import Vuetify from 'vuetify'
//  Vue.use(Vuetify)
  export default {
      
    data () {
      return {
        // activeBtn: ,
        
      }
    },
  }
</script>

<style scoped>
a{
  text-decoration: none !important;
}
</style>
